import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { getFiltersCountries } from 'api/filters'

export const CountriesContext = React.createContext({})

export const CountriesProvider = ({ children }) => {
  const [countriesOptions, setCountriesOptions] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    let isMounted = true

    getFiltersCountries()
      .then((data) => {
        if (!isMounted) return
        const options = data.map((option) => ({
          label: option.name,
          value: option.id,
          code: option.code,
          region: option.Region.name,
          regionId: option.Region.id
        }))
        setCountriesOptions(options)
      })
      .finally(() => {
        if (isMounted) setIsLoaded(true)
      })

    return () => {
      isMounted = false
    }
  }, [])

  const contextValue = useMemo(() => ({ countriesOptions }), [countriesOptions])

  if (!isLoaded) {
    return null
  }

  return (
    <CountriesContext.Provider value={contextValue}>
      {children}
    </CountriesContext.Provider>
  )
}

CountriesProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default CountriesProvider
